import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { X, KeyRound } from "lucide-react";

export default function AuthModal() {
  const { authOpen, setAuthOpen, authMode, setAuthMode, login, register } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  if (!authOpen) return null;
  const isLogin = authMode === "login";

  const submit = async (e) => {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      if (isLogin) await login(email, password);
      else await register(email, password, name);
    } catch (e2) {
      setErr(apiError(e2.response?.data?.detail) || "Something went wrong.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="wtk-modal-overlay" data-testid="auth-modal" onClick={() => setAuthOpen(false)}>
      <div className="wtk-modal" onClick={(e) => e.stopPropagation()}>
        <button className="wtk-modal-close" data-testid="auth-close" onClick={() => setAuthOpen(false)}><X size={18} /></button>
        <div className="wtk-modal-brand"><KeyRound size={22} className="wtk-brand-icon" /> What's the Key?</div>
        <h2 className="wtk-modal-title">{isLogin ? "Welcome back" : "Create your account"}</h2>
        <p className="wtk-modal-sub">{isLogin ? "Sign in to save progressions & join the community." : "Save your work and share it with the community."}</p>

        <form onSubmit={submit}>
          {!isLogin && (
            <input className="wtk-text-input" data-testid="auth-name" placeholder="Display name"
              value={name} onChange={(e) => setName(e.target.value)} />
          )}
          <input className="wtk-text-input" data-testid="auth-email" type="email" placeholder="Email"
            value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input className="wtk-text-input" data-testid="auth-password" type="password" placeholder="Password (min 6 chars)"
            value={password} onChange={(e) => setPassword(e.target.value)} required />
          {err && <p className="wtk-error" data-testid="auth-error">{err}</p>}
          <button className="wtk-analyze-btn" data-testid="auth-submit" disabled={busy} type="submit">
            {busy ? "Please wait…" : isLogin ? "Sign in" : "Create account"}
          </button>
        </form>

        <p className="wtk-modal-switch">
          {isLogin ? "New here? " : "Already have an account? "}
          <button data-testid="auth-switch" onClick={() => { setErr(null); setAuthMode(isLogin ? "register" : "login"); }}>
            {isLogin ? "Create an account" : "Sign in"}
          </button>
        </p>
      </div>
    </div>
  );
}
